import { useMemo, useState } from "react";
import styled from "styled-components";
import DesktopPageHeader from "../../../../components/DesktopPageHeader";
import { useToast } from "../../../../context/ToastContext";
import { useResto } from "../../../../hooks/useResto";
import { useOwnerRestaurantSelection } from "../../../../hooks/useOwnerRestaurantSelection";
import { useUser } from "../../../../hooks/useUser";
import { useDeviceType } from "../../../../hooks/useMediaQuery";
import apiClient from "../../../../helpers/apiClient";

const AtmCodesPage = ({ headerContent = null }) => {
  const toast = useToast();
  const { isOwner } = useUser();
  const { isDesktop } = useDeviceType();
  const { resto } = useResto();
  const { selectedOwnerRestaurant } = useOwnerRestaurantSelection();
  const sourceResto = isOwner ? selectedOwnerRestaurant : resto;
  const restoId = String(sourceResto?._id || sourceResto?.id || "");
  const restoName = sourceResto?.name || "";
  const restoAddress = sourceResto?.address || "";
  const avatar = sourceResto?.brand || "";
  const api = apiClient();
  const [code, setCode] = useState("");
  const [burningCode, setBurningCode] = useState(false);

  const normalizedCode = useMemo(() => code.trim(), [code]);

  const handleBurnCode = async () => {
    if (!normalizedCode || burningCode) return;

    try {
      setBurningCode(true);
      await api.post("/api/promotions/validate", { code: normalizedCode });
      toast.success("Código quemado correctamente.");
      setCode("");
    } catch (error) {
      toast.error(error?.message || "No se pudo quemar el código.");
    } finally {
      setBurningCode(false);
    }
  };

  const content = (
    <Page>
      <Card>
        <SectionTitle>Quemar código</SectionTitle>
        <HelperText>Ingresa el código promocional que quieres validar y consumir.</HelperText>
        <Field>
          <label htmlFor="atm-burn-code">Código</label>
          <input
            id="atm-burn-code"
            type="text"
            value={code}
            onChange={(event) => setCode(event.target.value.toUpperCase())}
            placeholder="Ej: ABC123"
            disabled={burningCode}
          />
        </Field>
        <PrimaryButton
          type="button"
          onClick={handleBurnCode}
          disabled={!normalizedCode || burningCode}
        >
          {burningCode ? "Quemando..." : "Quemar código"}
        </PrimaryButton>
      </Card>
    </Page>
  );

  if (!isDesktop) {
    return content;
  }

  return (
    <DesktopContainer>
      <DesktopPageHeader img={avatar} alt={restoName} />
      {headerContent}
      {content}
    </DesktopContainer>
  );
};

const DesktopContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

const Page = styled.div`
  width: 100%;
`;

const Card = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-sizing: border-box;
  border: 1px solid #e5e7eb;
`;

const SectionTitle = styled.h3`
  margin: 0 0 8px;
  font-size: 1.1rem;
  font-weight: 600;
  color: #111827;
`;

const HelperText = styled.p`
  margin: 0 0 16px;
  color: #6b7280;
  font-size: 14px;
`;

const Field = styled.div`
  display: grid;
  gap: 6px;
  margin-bottom: 16px;

  label {
    font-size: 13px;
    color: #374151;
  }

  input {
    width: 100%;
    height: 44px;
    border: 1px solid #d1d5db;
    border-radius: 10px;
    padding: 0 12px;
    font-size: 14px;
    box-sizing: border-box;
    outline: none;
  }
`;

const PrimaryButton = styled.button`
  border: 1px solid #111827;
  background: #111827;
  color: #fff;
  border-radius: 999px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export default AtmCodesPage;
